import {
  capitalize,
  capitalizeWords,
  lowercase,
  rmUnderscores,
} from './filters'

export const filters = { capitalize, capitalizeWords, lowercase, rmUnderscores }

export function initFilters(app) {
  app.config.globalProperties.$filters = filters
}
